import React from 'react';
import RsTableHeaderSortControl from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderSortControl';
import HeaderInfoTooltip from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoTooltip';
import HeaderInfoIcon from '@Pages/RetroSynthesis/ProjectRoutes/components/HeaderInfoIcon';
import TooltipContentRoutes from '@Pages/RetroSynthesis/ProjectRoutes/components/TooltipContentRoutes';
import TooltipContentBlocks from '@Pages/RetroSynthesis/ProjectRoutes/components/TooltipContentBlocks';
import TooltipContentConfidence from '@Pages/RetroSynthesis/ProjectRoutes/components/TooltipContentConfidence';
import Button from '@Components/Button';
import StructureToBase64 from '@Containers/StructureDialog/StructureToBase64';
import RsTableHeaderLabel from '@Pages/RetroSynthesis/components/RsTable/RsTableHeaderLabel';
import PropTypes from 'prop-types';
import TooltipContentFD from './TooltipContentFD';

import './ProjectRoutesTableHeader.theme.scss';

function ProjectRoutesTableHeader({
  sort,
  projectStructure,
  onSortChange,
  onStructureClick = () => null,
  isConfidenceColumnShown,
  isFirstDisconnectionColumnShown,
}) {
  return (
    <tr className="project-routes-table-header">
      <td>
        <RsTableHeaderLabel />
      </td>
      <th>
        <div>
          <RsTableHeaderSortControl sortList={sort} sortParam="routeNo" onChange={onSortChange}>
            No
          </RsTableHeaderSortControl>
        </div>
      </th>
      <th>
        <div className="project-routes-table-header__blocks">
          <HeaderInfoTooltip id="tooltip-building-blocks" rightAlign>
            <TooltipContentBlocks />
          </HeaderInfoTooltip>
          <HeaderInfoIcon tooltipId="tooltip-building-blocks" />
          Building blocks to target
          <StructureToBase64
            structure={projectStructure}
            /* eslint-disable-next-line react/no-unstable-nested-components */
            customRenderer={({ src }) => (
              <Button
                buttonConfig={{
                  className: 'project-routes-table-header__target-thumbnail-button',
                  e2eName: 'target-thumbnailp',
                  ariaLabel: 'Target thumbmail',
                }}
                onClick={() => onStructureClick(projectStructure)}>
                <img src={src} alt="Building blocks to target structure" className="project-routes-table-header__target-thumbnail-image" />
              </Button>
            )}
          />
          <RsTableHeaderSortControl sortList={sort} sortParam="stepCount" onChange={onSortChange}>
            No. of steps
          </RsTableHeaderSortControl>
        </div>
      </th>
      {isFirstDisconnectionColumnShown && (
        <th>
          <div className="project-routes-table-header__item">
            <HeaderInfoIcon tooltipId="tooltip-fd" />
            <HeaderInfoTooltip id="tooltip-fd">
              <TooltipContentFD />
            </HeaderInfoTooltip>
            First disconnection
          </div>
        </th>
      )}
      <th>
        <div className="project-routes-table-header__item">
          <HeaderInfoIcon tooltipId="project-routes-table-header" />
          Route topology
          <HeaderInfoTooltip id="project-routes-table-header">
            <TooltipContentRoutes />
          </HeaderInfoTooltip>
        </div>
      </th>
      {isConfidenceColumnShown && (
        <th>
          <div className="project-routes-table-header__item">
            <HeaderInfoIcon tooltipId="tooltip-confidence" />
            <HeaderInfoTooltip id="tooltip-confidence">
              <TooltipContentConfidence />
            </HeaderInfoTooltip>
            <RsTableHeaderSortControl sortList={sort} sortParam="confidence" onChange={onSortChange}>
              Score
            </RsTableHeaderSortControl>
          </div>
        </th>
      )}
      <th>Get to routes</th>
    </tr>
  );
}
ProjectRoutesTableHeader.propTypes = {
  sort: PropTypes.array,
  projectStructure: PropTypes.string,
  onSortChange: PropTypes.func,
  onStructureClick: PropTypes.func,
  isConfidenceColumnShown: PropTypes.bool,
  isFirstDisconnectionColumnShown: PropTypes.bool,
};

export default ProjectRoutesTableHeader;
